import styled from "styled-components";
import Button from "../../reusableComponents/Button/index.js";

export const ActionDetailsWrapper = styled.div`
  width: 40%;
  flex: 1;
  font-size: 0.875rem;
  padding-top: 1%;
  @media (max-width: 768px) {
    padding-top: 5%;
    width: 100%;
  }
`;

export const DetailLabel = styled.div`
  font-size: 0.8rem;
  font-weight: bold;
`;

export const DetailInfo = styled.div`
  font-size: 0.8rem;
  margin-bottom: 0.6rem;
`;

export const ActionDetailsButton = styled(Button)`
  height: 1.8rem;
  width: auto;
  font-weight: bold;
  padding-left: 5%;
  padding-right: 5%;
  margin: 0;
`;
